import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Apply runtime configuration from the hosting page
const config = window.__PWA_CONFIG__;
if (config) {
  if (config.app_title) {
    document.title = config.app_title;
  }
  if (config.theme_color) {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute('content', config.theme_color);
    }
  }
}

createRoot(document.getElementById('app')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
